/**
 * Google Analytics Configuration
 *
 * To use Google Analytics:
 * 1. Create a GA4 property at https://analytics.google.com
 * 2. Get your Measurement ID (format: G-XXXXXXXXXX)
 * 3. Set the VITE_GA_MEASUREMENT_ID environment variable
 * 4. For production, add it to your deployment environment variables
 */

export const analyticsConfig = {
  // Get GA Measurement ID from environment variable
  measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || "",

  /**
   * Enable/disable analytics based on environment
   *
   * This is the single source of truth for whether analytics should run.
   * Check this flag in your code: `if (analyticsConfig.enabled) { ... }`
   *
   * Temporarily enabled in dev mode for testing.
   * Production only: import.meta.env.VITE_GA_MEASUREMENT_ID && import.meta.env.PROD === true
   */
  enabled: Boolean(import.meta.env.VITE_GA_MEASUREMENT_ID),

  // Optional: Configure additional GA options
  options: {
    // Send pageviews automatically
    send_page_view: false, // We'll handle this manually for better control

    // Additional configuration
    cookieFlags: "SameSite=None;Secure",
  },

  // Debug mode (only in development)
  debug: import.meta.env.DEV === true,
};
